import Exchanges from '@domains/developers/views/Exchanges.vue'

import Layout from '@/container/Layout.vue'

export default [
  {
    path: 'developers',
    component: Layout,
    children: [
      {
        path: 'exchanges',
        component: Exchanges,
        name: 'Exchanges'
      }
    ]
  }
]
